import OriginalRadioGroup from './RadioGroup.svelte';
import GroupLabel from './GroupLabel.svelte';
import OriginalRadio from './Radio.svelte';
import Label from './Label.svelte';
import Description from './Description.svelte';
const RadioGroup = OriginalRadioGroup;
RadioGroup.Label = GroupLabel;
RadioGroup.Radio = OriginalRadio;
RadioGroup.Radio.Label = Label;
RadioGroup.Radio.Description = Description;
export default RadioGroup;
